import { IResponse } from '../types';
import axiosInstance from '../axiosInstance';
import { IInvoice } from './types';

export const getInvoices = (): IResponse<IInvoice[]> =>
  axiosInstance.get('ClientPortalInvoices/connectwise/invoices-for-company');

export const getInvoiceFile = (invoiceId: number): IResponse<any> =>
  axiosInstance.get(`ClientPortalInvoices/connectwise/invoice-pdf/${invoiceId}`, { responseType: 'blob' });
